import AppResource from 'general/constants/AppResource'
import DraggableModal from '../../DragableModal/DraggableModal'
import { useCallback, useEffect, useRef, useState } from 'react'
import KTFormGroup from 'general/components/Forms/KTFormGroup'
import { t } from 'i18next'
import KTFormInput, {
  KTFormInputType,
} from 'general/components/Forms/KTFormInput'
import _ from 'lodash'
import { useFormik } from 'formik'
import { useSelector } from 'react-redux'
import {
  REGISTRATION_COMPANY_TYPE,
  REGISTRATION_COMPANY_TYPE_MAP,
} from 'general/constants/AppConstants'
import KTFormSearchDropDown from 'general/components/Forms/KTFormSearchDropDown'
import ModalConfirm from '../../ModalConfirm'
import { REGEX_CMND_CCCD } from 'general/constants/AppRegex'
import ToastHelper from 'general/helpers/ToastHelper'
import { thunkGetTaxAuthority2025 } from 'features/System/systemSlice'
import { useDispatch } from 'react-redux'
import systemApi from 'api/systemApi'
import { thunkGetAccountProfile } from 'app/authSlice'
// import DraggableModal from '../../DraggableModal'

export const ChangeCompanyTypeModal = (props) => {
  const { show, setShow, company } = props
  const [childrenModal, setChildrenModal] = useState({})
  const setChildrenModalState = useCallback(
    (modalName, value) => {
      const clonedChildrenModal = { ...childrenModal }
      clonedChildrenModal[modalName] = value
      setChildrenModal(clonedChildrenModal)
    },
    [childrenModal],
  )
  const ref = useRef(null)
  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues: {
      companyType: company.companyType || '',
      taxCode: company.taxCode || '',
      identifyNumber: company.identifyNumber || '',
      companyName: company.companyName || '',
      provinceId: company.provinceId || '',
      businessPermitAddress: company.businessPermitAddress || '',
      taxAuthorityId: company.taxAuthority?.taxAuthorityId || '',
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      // validate tạm thời (refactor sau nếu cần)
      if (values.companyType === 'ENTERPRISE') {
        values.identifyNumber = null
      }
      if (!values.companyType) {
        ToastHelper.showError('Loại hình kinh doanh là bắt buộc')
        return
      }
      if (values.companyType === 'ENTERPRISE' && !values.taxCode) {
        ToastHelper.showError('Mã số thuế là bắt buộc')
        return
      }
      if (
        values.companyType === 'HOUSEHOLD' &&
        !values.identifyNumber?.trim()
      ) {
        ToastHelper.showError('Số căn cước công dân là bắt buộc')
        return
      }
      if (
        values.identifyNumber &&
        REGEX_CMND_CCCD.test(values.identifyNumber) === false &&
        values.companyType === 'HOUSEHOLD'
      ) {
        ToastHelper.showError('Số căn cước công dân không hợp lệ')
        return
      }
      if (!values.companyName?.trim()) {
        ToastHelper.showError('Tên công ty là bắt buộc')
        return
      }
      if (!values.provinceId) {
        ToastHelper.showError('Tỉnh/thành phố là bắt buộc')
        return
      }
      if (values.taxAuthorityId && !values.taxAuthorityId?.toString()?.trim()) {
        ToastHelper.showError('Cơ quan thuế quản lý là bắt buộc')
        return
      }
      const res = await systemApi.updateCompanyType(values)
      console.log('res', res)
      if (res.result == 'success')
        ToastHelper.showSuccess('Cập nhật thông tin doanh nghiệp thành công')
      setChildrenModalState('updateCompanyForm', false)
      setChildrenModalState('confirmChangeCompanyType', false)
      setChildrenModal({ ...childrenModal, updateCompanyForm: false })
      await dispatch(thunkGetAccountProfile())
    },
  })

  useEffect(() => {
    dispatch(
      thunkGetTaxAuthority2025({ provinceCityCode: formik.values.provinceId }),
    )
  }, [dispatch, formik.values.provinceId])

  return (
    <>
      <DraggableModal
        isOpen={show}
        setShow={(val) => {
          setShow(val)
        }}
        handleApplyChanges={() => {
          setShow(false)
          setChildrenModalState('updateCompanyForm', true)
        }}
        hasCancelButton={true}
        ref={ref}
        //   width={'55rem'}
        applyText="Cập nhật ngay"
        cancelText="Để sau"
        onOpenChange={() => {
          setShow(false)
        }}
      >
        <div className="d-flex justify-content-start p-5">
          <img
            src={AppResource.images.notifycationModal.imgChangeCompanyType}
            alt="Change VAT For Fuel"
            style={{ display: 'block', margin: '0 auto' }}
          />
        </div>
        <div display="flex" className="w-full">
          <p
            className="text-center"
            style={{ fontSize: '16px', fontWeight: '600' }}
          >
            Thông báo quan trọng về việc cập nhật loại hình kinh doanh và đơn vị
            hành chính mới
          </p>
          <p style={{ fontSize: '14px', fontWeight: '400' }}>
            Căn cứ theo <b>Thông tư 86/2024/TT-BTC</b>, có hiệu lực từ ngày
            <b>01/07/2025</b>, Quý khách vui lòng thực hiện cập nhật các thông
            tin sau để tiếp tục sử dụng dịch vụ:
          </p>
          <p>
            1. Khách hàng là <b>Hộ kinh doanh</b> cần cập nhật lại loại hình
            kinh doanh và <b>Căn cước công dân (CCCD) của chủ hộ kinh doanh</b>.
          </p>
          <p>
            2. Chuyển đổi đơn vị hành chính mới theo{' '}
            <b>Nghị quyết số 202/2025/QH15</b>.
          </p>
        </div>
      </DraggableModal>
      <ChildrenModal
        childrenModal={childrenModal}
        setChildrenModalState={setChildrenModalState}
        company={props.company}
        formik={formik}
        ref={ref}
      />
      <ModalConfirm
        show={childrenModal?.confirmChangeCompanyType}
        setShow={(val) => {
          setChildrenModalState('confirmChangeCompanyType', val)
        }}
        header="Cập nhật loại hình kinh doanh"
        content={
          <p>
            <b>Lưu ý: </b>Việc cập nhật CCCD chỉ được thực hiện{' '}
            <b>một lần duy nhất</b>. Sau khi xác nhận, thông tin định danh mới
            (CCCD) sẽ được dùng làm tên đăng nhập chính thức cho dịch vụ Quý
            khách đang sử dụng.
          </p>
        }
        handleConfirm={async () => {
          await formik.handleSubmit()
        }}
        btnConfirmProperties={{ type: 'submit' }}
        // inforSave
        // contentDetails
      />
    </>
  )
}

const ChildrenModal = (props) => {
  const { company, formik, childrenModal, setChildrenModalState } = props
  const ref = useRef()
  const { provinces, provinces2025, taxAuthorities2025 } = useSelector(
    (state) => state?.system,
  )
  const oldCompanyInfos = [
    {
      inputName: 'companyType',
      label: 'Loại hình kinh doanh',
      placeholder: 'Loại hình kinh doanh',
      value: REGISTRATION_COMPANY_TYPE_MAP[company.companyType],
      show: true,
      required: true,
      isDisabled: true,
      className: '',
    },
    {
      inputName: 'taxCode',
      label: 'Mã số thuế',
      placeholder: 'Mã số thuế',
      value: company.taxCode,
      show: company.companyType === 'ENTERPRISE',
      required: true,
      isDisabled: true,
      className: '',
    },
    {
      inputName: 'identifyNumber',
      label: 'Số căn cước công dân chủ hộ',
      placeholder: 'Số căn cước công dân chủ hộ',
      value: company.identifyNumber,
      show: company.companyType === 'HOUSEHOLD',
      required: true,
      isDisabled: true,
      className: '',
    },
    {
      inputName: 'companyName',
      label: 'Tên công ty',
      placeholder: 'tên công ty',
      value: company.companyName,
      show: true,
      required: true,
      isDisabled: true,
      className: '',
    },
    {
      inputName: 'provinceId',
      label: 'Tỉnh thành phố',
      placeholder: 'Tỉnh thành phố',
      value:
        provinces.find((province) => province.provinceId == company.provinceId)
          ?.name || '',
      show: true,
      required: true,
      isDisabled: true,
      className: '',
    },
    {
      inputName: 'businessPermitAddress',
      label: 'Địa chỉ đăng ký kinh doanh',
      placeholder: 'Địa chỉ đăng ký kinh doanh',
      value: company.businessPermitAddress,
      show: true,
      required: true,
      isDisabled: true,
      className: '',
    },
    // {
    //   inputName: 'taxAuthorityId',
    //   label: 'Cơ quan thuế chủ quản',
    //   placeholder: 'Cơ quan thuế chủ quản',
    //   value: company.taxAuthorityId,
    //   show: true,
    //   required: true,
    //   isDisabled: true,
    //   className: '',
    // },
  ]

  const newCompanyInfos = [
    {
      inputType: 'select',
      inputName: 'companyType',
      label: 'Loại hình kinh doanh',
      placeholder: 'Loại hình kinh doanh',
      options: REGISTRATION_COMPANY_TYPE,
      show: true,
      required: true,
      isDisabled: false,
      className: '',
    },
    {
      inputName: 'taxCode',
      label: 'Mã số thuế',
      placeholder: 'Mã số thuế',
      show: formik.values?.companyType === 'ENTERPRISE',
      required: formik.values?.companyType === 'ENTERPRISE',
      className: '',
      isDisabled: true,
    },
    {
      inputName: 'identifyNumber',
      label: 'Số căn cước công dân chủ hộ',
      placeholder: 'Số căn cước công dân chủ hộ',
      value: '',
      show: formik.values?.companyType === 'HOUSEHOLD',
      required: formik.values?.companyType === 'HOUSEHOLD',
      isDisabled: false,
      className: '',
    },
    {
      inputName: 'companyName',
      label: 'Tên công ty',
      placeholder: 'tên công ty',
      show: true,
      required: true,
      className: '',
    },
    {
      inputType: 'select',
      inputName: 'provinceId',
      label: 'Tỉnh/thành phố',
      placeholder: 'Tỉnh/thành phố',
      show: true,
      required: true,
      className: '',
      options: [{ name: '', value: '' }].concat(
        provinces2025?.map((item) => {
          return { name: item.name, value: item.provinceId }
        }),
      ),
    },
    {
      inputName: 'businessPermitAddress',
      label: 'Địa chỉ đăng ký kinh doanh',
      placeholder: 'Địa chỉ đăng ký kinh doanh',
      show: true,
      required: false,
      className: '',
    },
    {
      inputType: 'select',
      inputName: 'taxAuthorityId',
      label: 'Cơ quan thuế quản lý',
      placeholder: 'Cơ quan thuế quản lý',
      options: [{ name: '', value: '' }].concat(
        taxAuthorities2025?.map((item) => {
          return { name: item?.name, value: item?.taxAuthorityId }
        }),
      ),
      show: true,
      required: false,
      className: '',
    },
  ]
  return (
    <DraggableModal
      isOpen={childrenModal.updateCompanyForm}
      onOpenChange={(val) => {
        setChildrenModalState('updateCompanyForm', val)
      }}
      handleApplyChanges={() => {
        setChildrenModalState('updateCompanyForm', false)
        setChildrenModalState('confirmChangeCompanyType', true)
      }}
      ref={ref}
      title="Cập nhật loại hình kinh doanh"
      hasCancelButton={true}
      applyText="Cập nhật"
      cancelText="Hủy bỏ"
      width={'80%'}
    >
      {/* Your content here */}
      <div className="d-flex justify-content-start gap-10 p-5 row">
        <div className="col-6 block-inputs">
          <p>Thông tin hiện tại</p>
          {/* Add your form or input fields here */}
          {oldCompanyInfos.map((field, index) => {
            return (
              field.show && (
                <KTFormGroup
                  key={index}
                  label={
                    <>
                      {t(field.label)}{' '}
                      {field.required && (
                        <span className="text-danger">(*)</span>
                      )}
                    </>
                  }
                  inputName={field.inputName}
                  inputElement={
                    <KTFormInput
                      name={field.inputName}
                      value={field.value}
                      // enableCheckValid={isEditMode}
                      type={KTFormInputType.text}
                      placeholder={`${_.capitalize(t(field.placeholder))}`}
                      disabled={field.isDisabled}
                    />
                  }
                />
              )
            )
          })}
        </div>
        <div className="col-6 block-inputs">
          <p>Thông tin thay đổi</p>
          {/* Add your form or input fields here */}
          {newCompanyInfos.map((field, index) => {
            return (
              <div
                key={index}
                className={`${field.show ? '' : 'd-none '}` + field.className}
              >
                {(() => {
                  switch (field.inputType) {
                    case 'select':
                      return (
                        <>
                          <label>
                            {t(field.label)}{' '}
                            {field.required && (
                              <span className="text-danger">(*)</span>
                            )}
                          </label>
                          <KTFormSearchDropDown
                            name={field.inputName}
                            isCustom
                            options={field.options}
                            value={formik
                              .getFieldProps(field.inputName)
                              .value?.toString()}
                            onChange={(newValue) => {
                              formik
                                .getFieldHelpers(field.inputName)
                                .setValue(newValue)
                            }}
                            disabled={field.isDisabled}
                          />
                        </>
                      )
                    default:
                      return (
                        <KTFormGroup
                          label={
                            <>
                              {t(field.label)}{' '}
                              {field.required && (
                                <span className="text-danger">(*)</span>
                              )}
                            </>
                          }
                          inputName={field.inputName}
                          inputElement={
                            <KTFormInput
                              name={field.inputName}
                              value={
                                formik.getFieldProps(field.inputName).value
                              }
                              onChange={(value) => {
                                formik
                                  .getFieldHelpers(field.inputName)
                                  .setValue(value)
                              }}
                              onBlur={() => {
                                formik
                                  .getFieldHelpers(field.inputName)
                                  .setTouched(true)
                              }}
                              // enableCheckValid={isEditMode}
                              isValid={_.isEmpty(
                                formik.getFieldMeta(field.inputName).error,
                              )}
                              isTouched={
                                formik.getFieldMeta(field.inputName).touched
                              }
                              feedbackText={
                                formik.getFieldMeta(field.inputName).error
                              }
                              type={KTFormInputType.text}
                              placeholder={`${_.capitalize(t(field.placeholder))}`}
                              disabled={field.isDisabled}
                            />
                          }
                        />
                      )
                  }
                })()}
              </div>
            )
          })}
        </div>
      </div>
    </DraggableModal>
  )
}
